/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_DASHBOARD_COMPANY(state, payload) {
    state.companyID = payload.id
    state.companyName = payload.name
    state.apiID = payload.api_company_id
    state.latitude = payload.latitude
    state.longitude = payload.longitude
    state.wallet_amount = payload.wallet_amount
    state.total_users = payload.total_users
  },
  UPDATE_COMPANY_WALLET(state, payload) {
    state.wallet_amount = payload.wallet_amount
  }



}

